module.exports = __webpack_public_path__ + "static/media/locked.08469991.svg";